module.exports = __webpack_public_path__ + "static/media/1396894374902.7eca1129.jpg";